import './PriceMob.scss';
import React from 'react';
import { useState } from 'react';


function PriceMob({t,capture1,capture2,mobOwn,total,classname,botomTotalOwn,botomTotalWeExp}) {
   const mobOwnItem = (mobOwn(t)).map((item, index) => (
    <div key={index} className='price-mob-position-text'>
        <div className="price-item-capture-mob">
           {item.capture}     
        </div>
        <div className="price-data-mob">
            
            <div className="mob-description-item">
                {item.description1}
            </div>
            <div className="mob-description-item-bold">
                {item.description2}
            </div>
            
        </div>
    </div>
   ))
    
 
  return (
    <div  className={`${"price-card"} ${classname}`}>
        <div className="price-item-capture-mobile">
                <div>{capture1}</div>
                <div>{capture2}</div>
            </div>
        <div className="price-card-content-mob">
                {mobOwnItem}
            <div className="total-mob">
                <div className='bottom-total'>{total}</div>
                <div className="price-bottom-total-wrapper">
                    <div className='totalOwn'>{botomTotalOwn}</div>
                    <div className='totalWeExp'>{botomTotalWeExp}</div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default PriceMob;